import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { deleteBoat } from '../../services/AdminBoatService';

const BoatDeleteModal = ({ isOpen, onClose, onSuccess, boat }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await deleteBoat(boat.id);
      await onSuccess();
      onClose();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Boat</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <div className="admin__modal-body__delete_destination">
            <p>Are you sure you want to delete the boat with <strong>ID #{boat.id}</strong>?</p>
          </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoatDeleteModal;